/** @namespace Reducers.Accreditation */

import { IDS }       from '../components/accreditation/accreditation-action-id.constants';
import { TYPES }       from '../components/accreditation/accreditation-action-type.constants';

import { IDS as TASKS_ACTION_IDS }                  from '../components/accreditation/tasks/tasks-action-id.constants';
import { PREFIX as TASKS_ACTION_PREFIX }            from '../components/accreditation/tasks/tasks-action-type.constants';
import { TasksReducer }                             from '../components/accreditation/tasks/tasks.reducer';
import { tasksTabs }                                from '../components/accreditation/tasks/tasks-tabs';

import {IDS as AUDIT_ACTION_IDS }                   from '../components/accreditation/audit/audit-action-id.constants';
import {PREFIX as AUDIT_ACTION_PREFIX }             from '../components/accreditation/audit/audit-action-type.constants';
import { AuditReducer }                             from '../components/accreditation/audit/audit.reducer';
import { scheduleTabs }                             from "../components/accreditation/audit/schedule/schedule-tabs";

import {IDS as REQUIREMENTS_ASSES_ACTION_IDS }      from '../components/accreditation/requirements-assessment/requirements-assessment-action-id.constants';
import {PREFIX as REQUIREMENTS_ASSES_ACTION_PREFIX} from '../components/accreditation/requirements-assessment/requirements-assessment-action-type.constants';
import { RequirementsAssessmentReducer }            from '../components/accreditation/requirements-assessment/requirements-assessment.reducer';
import { requirementsAssessmentTabs }               from '../components/accreditation/requirements-assessment/requirements-assessment-tabs';

import { IDS as SETTINGS_ACTION_IDS }               from '../components/accreditation/settings/settings-action-id.constants';
import { PREFIX as SETTINGS_ACTION_PREFIX }         from '../components/accreditation/settings/settings-action-type.constants';
import { SettingsReducer }                          from '../components/accreditation/settings/settings.reducer';
import { evidenceTabs }                             from '../components/accreditation/settings/evidence/evidence-tabs';
import { requirementsTabs }                         from '../components/accreditation/settings/requirements/requirements-tabs';
import { sloRequiredDocsTabs }                      from '../components/accreditation/settings/slo-required-docs/slo-required-docs-tabs';
import { enabledAccountsTabs }                      from '../components/accreditation/settings/enabled-accounts/enabled-accounts-tabs';

import { IDS as ASSESSMENT_REPORTS_ACTION_IDS }     from '../components/accreditation/assessment-reports/assessment-reports-action-id.constants';
import { PREFIX as ASSESSMENT_REPORTS_PREFIX }      from '../components/accreditation/assessment-reports/assessment-reports-action-type.constants';
import { AssessmentReportsReducer }                 from '../components/accreditation/assessment-reports/assessment-reports.reducer';
import { assessmentReportsTabs }                    from '../components/accreditation/assessment-reports/assessment-reports-tabs';

import { IDS as ADD_DOCUMENT_ACTION_IDS }           from '../components/accreditation/add-document/add-document-action-id.constants';
import { PREFIX as ADD_DOCUMENT_ACTION_PREFIX }     from '../components/accreditation/add-document/add-document-action-type.constants';
import { AddDocumentReducer }                       from '../components/accreditation/add-document/add-document.reducer';
import { addDocumentTabs }                          from '../components/accreditation/add-document/add-document-tabs';

import { IDS as MASTER_DOC_LIST_ACTION_IDS }        from '../components/accreditation/master-doc-list/master-doc-list-action-id.constants';
import { PREFIX as MASTER_DOC_LIST_ACTION_PREFIX }  from '../components/accreditation/master-doc-list/master-doc-list-action-type.constants';
import { MasterDocListReducer }                     from '../components/accreditation/master-doc-list/master-doc-list.reducer';
import { masterDocListTabs }                        from '../components/accreditation/master-doc-list/master-doc-list-tabs';

import { IDS as IMPROVEMENT_ACTION_IDS }            from '../components/accreditation/improvement-actions/improvement-action-id.constants';
import { PREFIX as IMPROVEMENT_ACTION_PREFIX }      from '../components/accreditation/improvement-actions/improvement-action-type.constants';
import { ImprovementReducer }                       from '../components/accreditation/improvement-actions/improvement.reducer';
import { improvementTabs }                          from '../components/accreditation/improvement-actions/improvement-tabs';

import {INPUT_TEXT, INPUT_SELECT, INPUT_CHECKBOX} from '../common/form/input/input.constants'
import * as TABS from '../common/tabs/tabs.constants';
import {TabsReducer} from '../common/tabs/tabs.reducer';
import set from 'lodash/set';
import merge from 'lodash/merge';

/**
 * @function accreditationReducer
 * @param state {object}
 * @param action {object}
 * @returns {object} Redux Store
 * @memberOf Reducers
 */
export function accreditationReducer(state, action) {

    if (typeof state === 'undefined') {
        const currentYear = new Date().getFullYear();
        return {
          sectionsTree: [],
          simpleSectionsTree: [],
          navigationFilter: {
            hrs: ["actask"],
            sro: [],
            // default: ['actask'],
          },

          [IDS.accDashboardLocationYear]: {
            enabled: false,
            headOffices: [],
            headOffice: null,
            siteLocations: [],
            siteLocation: null,
            year: currentYear,
            availableYears: getAvailableYearsRange(currentYear),
          },

          [IDS.addRegulatoryFramework]: {
            leadingZerosOptions: [
              { value: "1", label: "1" },
              { value: "2", label: "2" },
              { value: "3", label: "3" },

              { value: "9", label: "a" },
              { value: "8", label: "A" },
            ],
            leadingZerosOptions3rdLevel: [
              {value: '1', label: '1'},
              {value: '2', label: '2'},
              {value: '3', label: '3'},
              {value: '9', label: 'a'},
              {value: '8', label: 'A'},
              {value: '0', label: 'Disabled'},
            ],
            level1_num_format: 1,
            level2_num_format: 1,
            level3_num_format: 1,
          },

          common: {
              documentTypes: [
                  {value: 'gdo', label: 'Generic Doc.'},
                  {value: 'pol', label: 'Policy'},
                  {value: 'pro', label: 'Procedure'},
                  {value: 'coa', label: 'Contracts/Agreements'},
                  {value: 'for', label: 'Form'},
                  {value: 'che', label: 'Checklist'},
              ]
          },

          accTasks: TasksReducer(),
          ...tasksTabs,

          accAssessmentReports: AssessmentReportsReducer(),
          ...assessmentReportsTabs,

          accAudit: AuditReducer(),
          ...scheduleTabs,

          rcoRequirementsAssessment: RequirementsAssessmentReducer(),
          ...requirementsAssessmentTabs,

          accSettings: SettingsReducer(),
          ...enabledAccountsTabs,
          ...evidenceTabs,
          ...requirementsTabs,
          ...sloRequiredDocsTabs,

          accAddDocument: AddDocumentReducer(),
          ...addDocumentTabs,

          masterDocList: MasterDocListReducer(),
          ...masterDocListTabs,

          rcoImprovement: ImprovementReducer(),
          ...improvementTabs,
        };
    }

    switch (action.type) {
        case TYPES.SELECT_ASSESSMENT_ITEM:
        case TYPES.FETCH_SITE_LOCATION_DETAILS:
            return state;
        case TYPES.LOCATION_SEARCH_BAR_CHANGE:
            return merge({...state}, {
                accDashboardLocationYear: action.accDashboardLocationYear
            })

        case TYPES.FETCH_SECTIONS_TREE_PROGRESS:
            return { ...state,
                sectionsTree: action.data,
            }

        case TYPES.SELECT_REQUIREMENT:
            const currentItem = state.selectedRequirement;
            if(currentItem)
                currentItem.selected = false;

            const sectionsList = index(state.sectionsTree);
            const newItem = action.requirementId ? sectionsList[action.requirementId] : null;
            const parent = sectionsList.find(section =>
                section
                && section.children
                && section.children.length
                && section.children.find(item => item.id === action.requirementId)
            );
            if(newItem) {
                return  { ...state,
                    selectedRequirement: {...newItem, selected: true},
                    selectedRequirementParent: parent,
                }
            }

        case TYPES.SECTIONS_TREE_UNSELECT_ALL:
            const unselectAllChildren = (children) => {
                children && children.forEach(item => {
                    if(item) {
                        item.selected = false
                        unselectAllChildren(item.children);
                    }
                })
                return children
            };
            return { ...state,
                sectionsTree: unselectAllChildren(state.sectionsTree),
            };

        case TYPES.SCHEME_SECTIONS_RESET:
            return merge({...state}, {
                accScheme: {
                    sections: {
                        selectedRequirement: null,
                    }
                }
            });

        case TYPES.FETCH_REQUIREMENTS_TREE:
            return {...state, simpleSectionsTree: action.data};

        case TYPES.SIMPLE_STD_TREE_UNSELECT_ALL:
            if(state.simpleSectionsTree && state.simpleSectionsTree.length) {
                state.simpleSectionsTree.forEach(topNode => {
                    topNode.selected = false;
                    unselectChildren(topNode);
                });
            }
            return { ...state, sectionDetails: null };

        case TYPES.FETCH_AUTOCO_EMPLOYEES_AND_MANAGERS:
            return set({...state}, action.path, action.data);
        case TYPES.FETCH_AUTOCOMPLETE_USER_DETAILS:
            state = set({...state}, action.detailsPath, {assignee: action.data});
            return set(state, action.autocompletePath, [action.data]);
        //*** COMMON ***
        case 'INPUT_TEXT_AREA_CHANGE':
        case INPUT_TEXT:
            if (action.id === IDS.addRegulatoryFramework) {
                return set({...state}, `${action.id}.${action.path}`, action.input)
            }
        case INPUT_CHECKBOX:
        case INPUT_SELECT:
            if ([IDS.addRegulatoryFramework, IDS.accDashboardLocationYear].includes(action.id)) {
                return set({...state}, `${action.id}.${action.path}`, action.input)
            }
        case TABS.TAB_INIT:
        case TABS.TAB_OVERRIDE:
        case TABS.TAB_PARAMS:
        case TABS.TAB_ENABLE:
        case TABS.TAB_DISABLE:
        case TABS.TAB_SHOW:
        case TABS.TAB_HIDE:
        case TABS.TAB_LOADING:
        case TABS.TAB_SELECT:
        case TABS.TAB_LABEL:
        case TABS.TAB_BUTTON_LABEL:
        case TABS.TAB_TRANSITION_DISABLE:
        case TABS.TAB_TRANSITION_ENABLE:
            if (action.id.startsWith('app.accreditation.')){
                return {
                    ...state,
                    [action.id]: TabsReducer(state[action.id], action)
                }
            }
        case TABS.TAB_SWITCH:
            if (action.id.startsWith('app.accreditation.')){
                return {
                    ...state,
                    [action.id]: Object.assign({}, state[action.id], {selectedTabIndex: action.selectedTabIndex, selectedState: action.selectedState})
                }
            }
    }

    if(action.type.startsWith(TASKS_ACTION_PREFIX)
        || action.id && TASKS_ACTION_IDS.hasOwnProperty(action.id.split('.').join('_'))) {
        return { ...state, accTasks: TasksReducer(state.accTasks, action) }
    }

    if(action.type.startsWith(ASSESSMENT_REPORTS_PREFIX)
    || action.id && ASSESSMENT_REPORTS_ACTION_IDS.hasOwnProperty(action.id.split('.').join('_'))) {
        return { ...state, accAssessmentReports: AssessmentReportsReducer(state.accAssessmentReports, action) }
    }

    if(action.type.startsWith(AUDIT_ACTION_PREFIX)
    || action.id && AUDIT_ACTION_IDS.hasOwnProperty(action.id.split('.').join('_'))) {
        return { ...state, accAudit: AuditReducer(state.accAudit, action) }
    }

    if(action.type.startsWith(REQUIREMENTS_ASSES_ACTION_PREFIX)
    || action.id && REQUIREMENTS_ASSES_ACTION_IDS.hasOwnProperty(action.id.split('.').join('_'))) {
        return { ...state, rcoRequirementsAssessment: RequirementsAssessmentReducer(state.rcoRequirementsAssessment, action) }
    }

    if(action.type.startsWith(SETTINGS_ACTION_PREFIX)
    || action.id && SETTINGS_ACTION_IDS.hasOwnProperty(action.id.split('.').join('_'))) {
        return { ...state, accSettings: SettingsReducer(state.accSettings, action) }
    }

    if(action.type.startsWith(ADD_DOCUMENT_ACTION_PREFIX)
    || action.id && ADD_DOCUMENT_ACTION_IDS.hasOwnProperty(action.id.split('.').join('_'))) {
        return { ...state, accAddDocument: AddDocumentReducer(state.accAddDocument, action) }
    }

    if(action.type.startsWith(MASTER_DOC_LIST_ACTION_PREFIX)
    || action.id && MASTER_DOC_LIST_ACTION_IDS.hasOwnProperty(action.id.split('.').join('_'))) {
        return {
          ...state,
          masterDocList: MasterDocListReducer(state.masterDocList, action),
        };
    }

    if(action.type.startsWith(IMPROVEMENT_ACTION_PREFIX)
        || action.id && IMPROVEMENT_ACTION_IDS.hasOwnProperty(action.id.split('.').join('_'))) {
        return { ...state, rcoImprovement: ImprovementReducer(state.rcoImprovement, action) }
    }

    return state;
}

const index = (children, list = []) => {
    children && children.forEach(item => {
        if(item) {
            list[parseInt(item.id)] = item;
            index(item.children, list);
        }
    })
    return list;
};

const unselectChildren = (node) => {
    node.selected = false
    if(node.children && node.children.length)
        node.children.forEach(childNode => {
            childNode.selected = false;
            unselectChildren(childNode);
        });
}

export function getAvailableYearsRange(year) {
    return [-2, -1, 0, 1]
        .map(i => i + year)
        .map(item => ({label: item, value: item}));
}